import axios from "axios";

const URL = process.env.VUE_APP_API;

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";
const NAME_CHANGE = "NAME_CHANGE";

const localToken = localStorage.getItem("bg-token");

axios.defaults.withCredentials = true;

if (localToken && typeof localToken === "string" && localToken.startsWith("Bearer ")) {
  axios.defaults.headers.common["Authorization"] = String(localToken);
} else {
  localStorage.removeItem("bg-token"); // Optional cleanup
  delete axios.defaults.headers.common["Authorization"];
}

const defaultState = {
  hasToken: localStorage.getItem("bg-token"),
  user: JSON.parse(localStorage.getItem("bg-user")),
};
const mutations = {
  [LOGIN](state) {
    state.pending = true;
  },
  [LOGIN_SUCCESS](state) {
    state.hasToken = true;
    state.pending = false;
    state.user = JSON.parse(localStorage.getItem("bg-user"));
  },
  [LOGOUT](state) {
    state.hasToken = false;
  },
  [NAME_CHANGE](state) {
    state.user = JSON.parse(localStorage.getItem("bg-user"));
  },
};

const actions = {
  login({ commit }, creds) {
    commit(LOGIN);
    return axios.post(`${URL}/tokens`, creds, { withCredentials: true })
      .then((res) => {
        const token = `Bearer ${res.data.access_token}`;
        localStorage.setItem("bg-token", token);
        localStorage.setItem("bg-user", JSON.stringify(res.data.user));
        axios.defaults.headers.common["Authorization"] = token;
        commit(LOGIN_SUCCESS);
        return res.data.user;
      })
      .catch((err) => {
        throw err.response.data.errors;
      });
  },

  logout({ commit }) {
    localStorage.removeItem("bg-token");
    localStorage.removeItem("bg-user");
    axios.defaults.headers.common["Authorization"] = null;
    commit(LOGOUT);
  },
  changeName({ commit }, payload) {
    localStorage.setItem("bg-user", JSON.stringify(payload));
    commit(NAME_CHANGE);
  },
};

const getters = {
  hasToken: (state) => {
    return () => state.hasToken;
  },
  user: (state) => {
    return () => state.user;
  },
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
